<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    location="right"
    origin="center center"
    transition="fade-transition"
    style="overflow-y: auto; bottom: 0;"
    content-class="downloads-menu"
    eager
  >
    <template v-slot:activator="{ props: menuActivatorProps }">
      <v-tooltip location="bottom" z-index="1200" :aria-label="$t('menus.topBars.downloads')">
        <template v-slot:activator="{ props: tooltipActivatorProps }">
          <v-btn
            v-if="downloadsCount > 0"
            v-bind="{ ...menuActivatorProps, ...tooltipActivatorProps }"
            class="mx-1"
            height="48px"
            :width="$vuetify.display.xs ? '36px' : '48px'"
            :elevation="0"
            rounded="large"
            :aria-label="$t('menus.topBars.downloads')"
            icon
          >
            <v-badge
              :model-value="activeDownloadsCount > 0"
              :content="activeDownloadsCount"
              color="primary"
              offset-x="4"
              offset-y="4"
            >
              <v-icon class="mr-0" size="28px">mdi-download-circle-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>{{ $t('menus.topBars.downloads') }}</span>
      </v-tooltip>
    </template>

    <v-card class="downloads-list-container">
      <v-card-text>
        <DownloadsList />
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { useNotificationStore } from '@/stores/NotificationStore.js'
import DownloadsList from './DownloadsList.vue'

export default {
  name: "DownloadsMenu",
  components: {
    DownloadsList,
  },
  data() {
    return {
      menu: false,
    };
  },
  mounted() {
    this.refreshDownloads();
  },
  watch: {
    menu: function(newValue) {
      if (newValue) {
        this.refreshDownloads();
      }
    },
  },
  methods: {
    refreshDownloads() {
      const notificationStore = useNotificationStore();
      notificationStore.refreshDownloads();
    },
  },
  computed: {
    activeDownloadsCount: function() {
      const notificationStore = useNotificationStore();
      return notificationStore.getActiveDownloadsCount;
    },
    downloadsCount: function() {
      const notificationStore = useNotificationStore();
      return notificationStore.getDownloads.length;
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.downloads-menu) {
  width: 500px;
  top: 80px !important;
  bottom: 5px !important;
  border-radius: 8px;

  > .downloads-list-container {
    min-height: 100%;
  }
}

@media only screen and (max-width: 600px) {
  :deep(.downloads-menu) {
    min-width: 100%;
    top: 60px !important;
    left: 0 !important;
    right: 0 !important;
  }
}
</style>
